import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface ManagerUser {
  avatar: string | null
  email: string
  firstName: string
  isActive: boolean
  lastName: string
  locale?: string | null
}

export interface Manager {
  createdAt: number
  id: number
  user: ManagerUser
}

export const USE_GET_MANAGERS_QUERY_KEY = 'useGetManagers'

// Note: BE has no query params for this list - the path segments are skip and limit
export const getManagers = async (signal?: AbortSignal) => {
  const response = await authAPI.get<Manager[]>('/manager/0/999999999', { signal })
  return response.data
}

export const useGetManagers = () => {
  return useQuery({
    queryFn: ({ signal }) => getManagers(signal),
    queryKey: [USE_GET_MANAGERS_QUERY_KEY],
  })
}

export const useInvalidateManagers = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_MANAGERS_QUERY_KEY] })
}
